import GeneralMeeting from "./GeneralMeeting.container.view";

export default GeneralMeeting;
